export default "__VITE_ASSET__CBoCjfu2__"